import type { MaybeRefOrGetter } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

/**
 * Head tags for page 2+ of a listing, the same rules as /organizacie: "– strana N" in the
 * title so the paginated URLs are not duplicates of page 1, and a self-canonical so Google
 * keeps them (and the items listed only there) instead of folding them into page 1.
 * Filtered views (any other query param) keep the listing canonical from app.vue.
 */
export function useListingPaginationHead(page: MaybeRefOrGetter<number>) {
    const route = useRoute()

    useHead(() => {
        const current = toValue(page)
        if (current <= 1) return {}

        const onlyPageParam = Object.keys(route.query).every((key) => key === 'page')

        return {
            titleTemplate: (title?: string) =>
                title ? `${title.replace(/\s*\|\s*GROWNi(\.sk)?\s*$/, '')} – strana ${current} | GROWNi.sk` : '',
            // `key` dedupes against the site-wide canonical set in app.vue
            link: onlyPageParam
                ? [{ rel: 'canonical', key: 'canonical', href: `https://growni.sk${route.path}?page=${current}` }]
                : []
        }
    })
}

/** Link to another page of the current listing, keeping its filters; page 1 is the clean URL. */
export function listingPageRoute(query: Record<string, unknown>, page: number): RouteLocationRaw {
    return { query: { ...query, page: page > 1 ? String(page) : undefined } } as RouteLocationRaw
}
